import React, { useContext, useEffect, useState } from 'react';
import FavouriteAccounts from './FavouriteAccounts';
import AllAccounts from './AllAccounts';
import { AccountListContext } from '../../../context/AccountListContext';
import './Accounts.css';
import useAuth from '../../../hooks/useAuth';
import { useLocation, useParams } from 'react-router-dom';
import { getUrlDetailsObj, getUserStatsObject, recordActivity } from '../../../services/commonService';
import { useUser } from '../../../context/UserContext';
import AddAccountContainer from '../genericComponents/chatbotContainer/AddAccountContainer';
import GenericOverviewSideCard from '../genericComponents/GenericOverviewSideCard';

export default function Accounts() {

    useAuth();
    var currentUrl = useLocation().pathname;
    const [loader, setLoader] = useState(false);
    const context = useContext(AccountListContext);
    const { loading } = context;
    const { user } = useUser();
    const [currentRoleKey, setCurrentRoleKey] = useState(user?.role_key);

    const pageParsedData = getUrlDetailsObj(useLocation, useParams);
    const [showMoreModal, setShowMoreModal] = useState(false);

    useEffect(() => {
      if(user?.company_id){
          const userStat = getUserStatsObject("Companies", "page_load", "Page Source: Companies", currentUrl);
          userStat.url_details = pageParsedData;
          recordActivity(userStat);
      }
    }, [user?.company_id])

    useEffect(() => {
      setCurrentRoleKey(user?.role_key);
    }, [user?.role_key])

    useEffect(() => {
      setLoader(loading);
    }, [loading]);

    return (
        <div className='container-fluid'>
          {/* {loader && <LazyCompLoader />} */}

            <div className='row'>
              {/* {showMoreModal && (
                <GenericOverviewSideCard
                  showMoreModal={showMoreModal}
                  setShowMoreModal={setShowMoreModal}
                  titleForSideCard={null}
                  comp={<AddAccountContainer onBack={() => (true)} type={"spot"} />}
                  minWidthForDrawer={"30%"}
                />
              ) } */}
              {/* <FavouriteAccounts /> */}
              <AllAccounts setShowMoreModal={setShowMoreModal} />
            </div>

        </div>
    );
}
